import React from "react";
import { useNavigate } from "react-router-dom";

const PendingTradeAlert = ({ isOpen, pendingCount = 0, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen || pendingCount <= 0) {
    return null;
  }

  const pendingLabel = pendingCount === 1 ? "trade" : "trades";

  const handleViewTrades = () => {
    onClose?.();
    navigate("/trading");
  };

  return (
    <div style={styles.overlay} role="dialog" aria-modal="true">
      <div style={styles.card}>
        <h2 style={styles.title}>Trade Request Waiting</h2>
        <p style={styles.message}>
          You have {pendingCount} pending {pendingLabel} waiting for your
          response.
        </p>
        <div style={styles.actions}>
          <button
            type="button"
            style={styles.secondaryButton}
            onClick={onClose}
          >
            Later
          </button>
          <button
            type="button"
            style={styles.primaryButton}
            onClick={handleViewTrades}
          >
            Go to Trading
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(2, 6, 26, 0.68)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1200,
    padding: "1rem",
  },
  card: {
    width: "min(420px, 100%)",
    borderRadius: "12px",
    border: "1px solid rgba(0,245,212,0.34)",
    background: "rgba(7, 20, 60, 0.95)",
    boxShadow:
      "0 20px 42px rgba(0,0,0,0.46), inset 0 0 0 1px rgba(0,245,212,0.08)",
    padding: "1rem",
  },
  title: {
    margin: "0 0 0.5rem",
    color: "#eaf3ff",
    fontSize: "1.04rem",
  },
  message: {
    margin: "0 0 0.9rem",
    color: "#c9ddff",
    fontSize: "0.9rem",
    lineHeight: 1.4,
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "0.55rem",
    flexWrap: "wrap",
  },
  primaryButton: {
    padding: "0.44rem 0.78rem",
    borderRadius: "9px",
    border: "1px solid rgba(0,245,212,0.7)",
    background: "rgba(0,245,212,0.14)",
    color: "#a8fff0",
    fontWeight: "bold",
    cursor: "pointer",
  },
  secondaryButton: {
    padding: "0.44rem 0.78rem",
    borderRadius: "9px",
    border: "1px solid rgba(98,132,212,0.55)",
    background: "rgba(5,17,51,0.85)",
    color: "#a6bce6",
    fontWeight: "bold",
    cursor: "pointer",
  },
};

export default PendingTradeAlert;
